import { DropzoneAreaField } from '~/common/components';

import { Trans } from '~/common/context';
import { Button, Col, FormContainer, notify, Row } from '@wyz/ui';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { importForm } from '~/connect/schemas';
import { IImportForm } from '~/connect/types';
import { useManageJobs } from '~/common/api';
import { IJob } from '~/common/types';
import { useCommonErrorTranslation } from '~/common/hooks';

type Props = {
  type: IJob['type'];
};
export default function ImportForm({ type }: Props) {
  const methods = useForm<IImportForm>({
    resolver: zodResolver(importForm),
  });
  const { resolveErrorKey } = useCommonErrorTranslation();

  const manageJobs = useManageJobs({ create: { enabled: true } });

  return (
    <FormContainer
      methods={methods}
      submitHandler={(formData) => {
        manageJobs.create.mutate(
          { ...formData, type },
          {
            onSuccess: () => {
              notify.success(<Trans i18nKey='app.common.messages.success' />, {
                id: 'toast-success-import-job-created',
              });
            },
            onError: (error: NonNullable<typeof manageJobs.create.error>) => {
              notify.error(<Trans i18nKey={resolveErrorKey(error.message)} />, {
                id: 'toast-error-import-job-failed',
              });
            },
          },
        );
      }}
    >
      <Row>
        <Col>
          <DropzoneAreaField
            name='file'
            filesLimit={1}
            label={<Trans i18nKey='app.common.button.new_import' />}
            acceptedFiles='XLSX'
          />
        </Col>
      </Row>
      <Row>
        <Col className='d-flex justify-content-end'>
          <Button
            id='run-import'
            type='submit'
            variant='primary'
            isLoading={manageJobs.create.isLoading}
          >
            <Trans i18nKey='app.common.button.new_import' />
          </Button>
        </Col>
      </Row>
    </FormContainer>
  );
}
